import { CHANGE_VALUES_PRESTATION_TYPE } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'

export const contractSaveParametersGeneration = ({
  contactPreferences = {},
  billingData = {},
  contractData = {},
  characteristicsData = {},
  energyConsumptionData = {},
  electricityMeterData = {},
  gasMeterData = {},
  mainAddressData = {},
  contractId,
  contactId,
  addressId,
  billingAddressId,
  residenceAddressId,
  action = 'save',
  type,
}) => {
  const options = new URLSearchParams()
  const { electricityMeter = {}, gasMeter = {} } = mainAddressData
  const isChangePrestation = CHANGE_VALUES_PRESTATION_TYPE.includes(characteristicsData.prestationType)
  const isElecOrDual = characteristicsData.energyType === 'elec' || characteristicsData.energyType === 'dual'
  const isGasOrDual = characteristicsData.energyType === 'gas' || characteristicsData.energyType === 'dual'

  options.append('action', action)
  options.append('type', type || '')
  options.append('id', contractId || '')
  options.append('contact_id', contactId || '')
  options.append('address_id', addressId || '')
  options.append('client_type', contactPreferences.clientType || '')
  options.append('prestation_type', characteristicsData.prestationType || '')
  options.append('energy_type', characteristicsData.energyType || '')

  options.append('offer_id', contractData.offerId ? parseInt(contractData.offerId) : '')
  options.append('organisation_id', contractData.providerId ? parseInt(contractData.providerId) : '')

  options.append('invoice_sending_mode', billingData.sendingMode || '')
  options.append('payment_mode', billingData.paymentMode || '')
  options.append('iban', billingData.iban || '')

  if (billingData.bic?.length > 0) {
    options.append('bic', billingData.bic)
  }

  if (billingData.accountHolderTaxIdCode) {
    options.append('account_holder_tax_id_code', billingData.accountHolderTaxIdCode)
  }

  if (billingData.differentAccountHolder === true) {
    options.append('owner_name_different', 1)
    options.append('owner_lastname', billingData.accountHolderLastname || '')
    options.append('owner_firstname', billingData.accountHolderFirstname || '')
  }

  if (billingAddressId) {
    options.append('billing_address_id', billingAddressId)
  }

  if (residenceAddressId) {
    options.append('residence_address_id', residenceAddressId)
  }

  if (contractData.italyDoiPhone) {
    options.append('italy_doi_phone', contractData.italyDoiPhone)
  }
  if (contractData.italyDoiPrivacy) {
    options.append('italy_doi_privacy', contractData.italyDoiPrivacy)
  }

  if (isElecOrDual) {
    options.append('meter_id_elec', electricityMeter.pdlNo || '')
    options.append(
      'provider_external_id_elec',
      contractData.providerExternalId || electricityMeterData.providerExternalId || '',
    )

    if (electricityMeterData.meterPower) {
      options.append('meter_power_elec', electricityMeterData.meterPower)
    }
    if (electricityMeterData.originalMeterPower) {
      options.append('original_meter_power_elec', electricityMeterData.originalMeterPower)
    }
    if (electricityMeterData.meterOption) {
      options.append('meter_option_elec', electricityMeterData.meterOption)
    }
    if (electricityMeterData.usage) {
      options.append('usage_type_elec', electricityMeterData.usage)
    }
    if (electricityMeterData.voltage) {
      options.append('voltage_elec', electricityMeterData.voltage)
    }
    if (electricityMeterData.distributor) {
      options.append('distributor_elec', electricityMeterData.distributor)
    }
    if (electricityMeterData.originMarket) {
      options.append('origin_market_elec', electricityMeterData.originMarket)
    }
    if (isChangePrestation && electricityMeterData.energySupplier) {
      options.append('supplier_id_elec', electricityMeterData.energySupplier)
    }

    options.append('consumption_base', energyConsumptionData.consumptionBase || 0)
    options.append('consumption_biorariaF1', energyConsumptionData.consumptionBiorariaF1 || 0)
    options.append('consumption_biorariaF2', energyConsumptionData.consumptionBiorariaF2 || 0)
    options.append('consumption_biorariaF3', energyConsumptionData.consumptionBiorariaF3 || 0)
  }

  if (isGasOrDual) {
    options.append('meter_id_gas', gasMeter.pceNo || '')
    options.append('car_gas', energyConsumptionData.carGas || 0)

    if (gasMeterData.usage) {
      options.append('usage_type_gas', gasMeterData.usage)
    }
    if (gasMeterData.distributor) {
      options.append('distributor_gas', gasMeterData.distributor)
    }
    if (gasMeterData.originMarket) {
      options.append('origin_market_gas', gasMeterData.originMarket)
    }
    if (isChangePrestation && gasMeterData.energySupplier) {
      options.append('supplier_id_gas', gasMeterData.energySupplier)
    }
    if (gasMeterData.providerExternalId) {
      options.append('provider_external_id_gas', gasMeterData.providerExternalId)
    }
    if (gasMeterData.distributorCode) {
      options.append('distributor_code_gas', gasMeterData.distributorCode)
    }
    if (gasMeterData.daysOfUse) {
      options.append('days_of_use_gas', gasMeterData.daysOfUse)
    }
    if (gasMeterData.meterCategory) {
      options.append('meter_category_gas', gasMeterData.meterCategory)
    }
    if (gasMeterData.maxThermalCapacity) {
      options.append('max_thermal_capacity_gas', gasMeterData.maxThermalCapacity)
    }
  }

  return options
}
